import Vue from 'vue';
import VueRouter from 'vue-router';
import TestRunIndex from '../views/TestRunIndex.vue';
import TargetBuildPlatformSummary from '../views/TargetBuildPlatformSummary.vue';
import TargetBuildHistory from '../views/TargetBuildHistory.vue';
import LogsSearching from "../views/LogsSearching";
import ManualUploadXml from "@/views/ManualUploadXml";
import AboutPage from "@/views/AboutPage";
import XmlUploadRequestsIndex from "@/views/XmlUploadRequestsIndex";
import XmlUploadRequest from "@/views/XmlUploadRequest";
import UploadRequestResultsIndex from "@/views/UploadRequestResultsIndex.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'TestRunIndex',
    component: TestRunIndex,
    props: {
      defaultFilterValues: {
        timeInterval: "-1",
      },
    },
  },
  {
    path: '/columnstore_weekly_release_tests',
    name: 'ColumnstoreWeeklyReleaseTests',
    component: TestRunIndex,
    props: {
      defaultFilterValues: {
        targetRegexp: "^columnstore-release|^columnstore-weekly",
        timeInterval: "7",
      },
      fetchOnCreated: true,
    },
  },
  {
    path: '/requests_results',
    name: 'UploadRequestResultsIndex',
    component: UploadRequestResultsIndex,
  },
  {
    path: '/by_platform',
    name: 'TargetBuildPlatformSummary',
    component: TargetBuildPlatformSummary,
  },
  {
    path: '/target_builds',
    name: 'TargetBuildHistory',
    component: TargetBuildHistory,
    props: {
      fetchOnCreated: true,
    },
  },
  {
    path: '/logs_search',
    name: 'LogsSearch',
    component: LogsSearching,
  },
  {
    path: '/manual_upload',
    name: 'ManualUpload',
    component: ManualUploadXml,
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: AboutPage,
  },
  {
    path: '/requests',
    name: 'XmlUploadRequestsIndex',
    component: XmlUploadRequestsIndex,
  },
  {
    path: '/requests/:id',
    name: 'XmlUploadRequestShow',
    component: XmlUploadRequest,
    props: (route) => ({ id: route.params.id }),
  },
];

const router = new VueRouter({
  routes,
  base: process.env.VUE_APP_BASE_PATH,
  mode: 'history',
});

export default router;
